//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { directive } from 'vue-awesome-swiper'
// import ChartSingleCoin from '@/components/landing/chart_single_coin'
export default {
  name: 'CoinSlider',
  directives: {
    swiper: directive
  },
  components: {
    // ChartSingleCoin
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 15,
        slidesPerGroup: 1,
        loop: true,
        grabCursor: true,
        freeMode: {
          enabled: true,
          sticky: true
        },
        speed: 5000,
        autoplay: {
          delay: 5000
        },
        draggable: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1199: {
            spaceBetween: 50
          },
          991: {
            slidesPerView: 3
          },
          767: {
            slidesPerView: 3
          },
          0: {
            slidesPerView: 1
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      coins: 'coins/coins',
      getSymbolFaName: 'coins/getSymbolFaName',
      buyDollarPrice: 'coins/buyDollarPrice'
    })
  }
}
